import React from "react";

const FullScreenSpace = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="11.7071"
        y1="11.2929"
        x2="16.7071"
        y2="16.2929"
        stroke="#023a4a"
        strokeWidth="2"
      />
      <line
        y1="-1"
        x2="7.07107"
        y2="-1"
        transform="matrix(-0.707107 0.707107 0.707107 0.707107 29 12)"
        stroke="#023a4a"
        strokeWidth="2"
      />
      <line
        x1="16.7071"
        y1="23.7071"
        x2="11.7071"
        y2="28.7071"
        stroke="#023a4a"
        strokeWidth="2"
      />
      <line
        x1="28.2929"
        y1="28.7071"
        x2="23.2929"
        y2="23.7071"
        stroke="#023a4a"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 10H16V12H12V16H10V12V10H12ZM10 24V27.9998V29.9998H12H16V27.9998H12V24H10ZM27.9998 24V27.9998H24V29.9998H27.9998H29.9998V27.9998V24H27.9998ZM29.9998 16V12V10H27.9998H24V12H27.9998V16H29.9998Z"
        fill="#023a4a"
      />
    </svg>
  );
};

export default FullScreenSpace;
